import { useAppDispatch, useAppSelector } from "../../store";
import { themeActions } from "./ThemeReducer";
import { ITheme, defaultTheme } from "./Theme.types";

export function useTheme() {
  const dispatch = useAppDispatch();

  const activeTheme = useAppSelector(({ theme }) => {
    if (!theme.active) {
      if (!!theme.themes.length) {
        return theme.themes[0];
      }
      return defaultTheme;
    }
    const activeTheme = theme.themes.find((t) => t.key === theme.active);
    if (!activeTheme) {
      console.warn(`Theme with key ${theme.active} not found!`);
      return defaultTheme;
    }
    return activeTheme;
  });

  const setTheme = (theme: string) => {
    dispatch(themeActions.setActiveTheme(theme));
  };

  const setThemes = (themes: ITheme[]) => {
    dispatch(themeActions.setThemes(themes));
  };

  return { theme: activeTheme, setTheme, setThemes };
}

export function useThemes() {
  return useAppSelector(({ theme }) => theme.themes);
}
